import { z } from 'zod';
import { AddressSchema } from './address';
import { FamilyId, OrgId, ApplicantId } from '../types/branded';
import { FamilyStatusSchema, FamilyWorkflowStatusSchema } from '../types/enums';

export const FamilySchema = z.object({
  id: FamilyId,
  orgId: OrgId,
  applicantId: ApplicantId.nullable().optional(),
  familyName: z.string().min(1),
  address: AddressSchema,
  homePhone: z.string().nullable().optional(),
  status: FamilyStatusSchema,
  workflowStatus: FamilyWorkflowStatusSchema.nullable().optional(),
  synagogue: z.string().nullable().optional(),
  rabbi: z.string().nullable().optional(),
  hebrewFamilyName: z.string().nullable().optional(),
  maritalStatus: z.string().nullable().optional(),
  adoptedChild: z.string().nullable().optional(),
  stepParent: z.string().nullable().optional(),
  siblings: z.array(z.object({
    name: z.string(),
    age: z.string().nullable().optional(),
    school: z.string().nullable().optional(),
  })).default([]),
  grandparents: z.object({
    paternal: z.object({
      names: z.string().nullable().optional(),
      location: z.string().nullable().optional(),
      phone: z.string().nullable().optional(),
      family: z.string().nullable().optional(),
    }).nullable().optional(),
    maternal: z.object({
      names: z.string().nullable().optional(),
      location: z.string().nullable().optional(),
      phone: z.string().nullable().optional(),
      family: z.string().nullable().optional(),
    }).nullable().optional(),
  }).nullable().optional(),
  paternalGrandparents: z.object({
    names: z.string().nullable().optional(),
    location: z.string().nullable().optional(),
    phone: z.string().nullable().optional(),
    family: z.string().nullable().optional(),
  }).nullable().optional(),
  maternalGrandparents: z.object({
    names: z.string().nullable().optional(),
    location: z.string().nullable().optional(),
    phone: z.string().nullable().optional(),
    family: z.string().nullable().optional(),
  }).nullable().optional(),
  tags: z.array(z.string()).default([]),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type Family = z.infer<typeof FamilySchema>;
